import { DefaultTitleError, InvalidTokenError, DefaultError, NetworkError, ForbiddenError } from '../constants/messages';
import store from '../redux/store';
import history from '../helpers/history';
import { logoutUser } from '../redux/auth/authSlice';


const CODE_UNAUTHORIZED = 401;
const CODE_FORBIDDEN = 403;
const MSG_NETWORK_ERROR = 'Network Error';

function handleMessage(error) {
    const { response } = error;

    const { status, data = {} } = response;

    switch (status) {
        case CODE_UNAUTHORIZED:
            store.dispatch(logoutUser({
                refreshToken: store.getState().auth?.user?.refreshToken,
                errors: InvalidTokenError,
                navigate: undefined,
                history
            }));
            return { messages: [''] };
        case CODE_FORBIDDEN:
            return { status, title: DefaultTitleError, messages: [ForbiddenError] };
        default:
            const { errors = {}, title = DefaultTitleError } = data;
            const { messages = [DefaultError] } = errors;
            return { status, title, messages };
    }
};

export function responseError(response) {
    try {
        const error = handleMessage(response);
        return Promise.reject(error);
    }
    catch {
        const { message } = response;
        let messageAlert = DefaultError;

        if (MSG_NETWORK_ERROR === message)
            messageAlert = NetworkError;

        const status = 500;
        const messages = [messageAlert];

        return Promise.reject({ status, title: DefaultTitleError, messages });
    }
};